import axios from "axios";
import Cookies from "js-cookie";

import { getCleanBrandNames } from "../../utilities";
import { receiveServerErrors } from "../../Shared/Errors/errorActions";

export const REQUEST_PRODUCTS = "REQUEST_PRODUCTS";
export const UPDATE_PRODUCT_PARAMS = "UPDATE_PRODUCT_PARAMS";
export const RECEIVE_PRODUCTS = "RECEIVE_PRODUCTS";
export const RECEIVE_CREATE_PRODUCT = "RECEIVE_CREATE_PRODUCT";
export const REMOVE_ADDED_PRODUCT_INFO = "REMOVE_ADDED_PRODUCT_INFO";
export const RECEIVE_UPDATE_PRODUCT = "RECEIVE_UPDATE_PRODUCT";
export const CLEAR_UPDATED_PRODUCT_DATA = "CLEAR_UPDATED_PRODUCT_DATA";
export const REQUEST_PRODUCT = "REQUEST_PRODUCT";
export const RECEIVE_PRODUCT = "RECEIVE_PRODUCT";
export const REQUEST_PRODUCT_VIDEOS = "REQUEST_PRODUCT_VIDEOS";
export const REQUEST_ADD_PRODUCT_HASHTAG = "REQUEST_ADD_PRODUCT_HASHTAG";
export const REQUEST_EDIT_PRODUCT_HASHTAG = "REQUEST_EDIT_PRODUCT_HASHTAG";
export const RECEIVE_PRODUCT_UPDATE_ERRORS = "RECEIVE_PRODUCT_UPDATE_ERRORS";
export const RECEIVE_PRODUCT_VIDEOS = "RECEIVE_PRODUCT_VIDEOS";
export const REQUEST_PRODUCT_INFLUENCERS = "REQUEST_PRODUCT_INFLUENCERS";
export const RECEIVE_PRODUCT_INFLUENCERS = "RECEIVE_PRODUCT_INFLUENCERS";
export const REQUEST_PRODUCT_NAMES = "REQUEST_PRODUCT_NAMES";
export const RECEIVE_PRODUCT_NAMES = "RECEIVE_PRODUCT_NAMES";
export const RECEIVE_PRODUCT_ERRORS = "RECEIVE_PRODUCT_ERRORS";
export const RECEIVE_AUTO_COMPLETE_PRODUCT_OR_HASHTAG_LIST =
  "RECEIVE_AUTO_COMPLETE_PRODUCT_OR_HASHTAG_LIST";
export const RECEIVE_AUTO_COMPLETE_PRODUCT_OR_HASHTAG_CATEGORIES =
  "RECEIVE_AUTO_COMPLETE_PRODUCT_OR_HASHTAG_CATEGORIES";
export const RESET_FILTERS_PRODUCTS = "RESET_FILTERS_PRODUCTS";
export const RESET_PRODUCTS_DATA = "RESET_PRODUCTS_DATA";
export const PRODUCT_PAGE_STATES = "PRODUCT_PAGE_STATES";

export const doResetFiltersProducts = () => ({
  type: RESET_FILTERS_PRODUCTS,
});

export const doResetProductsData = () => ({
  type: RESET_PRODUCTS_DATA,
});

export const updateProductPageState = (status) => ({
  type: PRODUCT_PAGE_STATES,
  status,
});

// const { REACT_APP_BASE_URL } = process.env

const requestProducts = () => ({ type: REQUEST_PRODUCTS });

const requestProductVideos = (id) => ({ type: REQUEST_PRODUCT_VIDEOS, id });
const requestAddProdsHashtag = (name) => ({
  type: REQUEST_ADD_PRODUCT_HASHTAG,
  name,
});
const requestEditProdsHashtag = () => ({ type: REQUEST_EDIT_PRODUCT_HASHTAG });

const requestProductInfluencers = (id) => ({
  type: REQUEST_PRODUCT_INFLUENCERS,
  id,
});

const requestProductNames = () => ({ type: REQUEST_PRODUCT_NAMES });

const receiveProducts = ({ products, data }) => ({
  type: RECEIVE_PRODUCTS,
  products,
  data: getCleanBrandNames(data),
});

const receiveCreateProduct = ({ data }) => ({
  type: RECEIVE_CREATE_PRODUCT,
  data,
});

export const removeCreateProductInfo = () => ({
  type: REMOVE_ADDED_PRODUCT_INFO,
});

const receiveUpdateProduct = ({ data }) => ({
  type: RECEIVE_UPDATE_PRODUCT,
  data,
});

const receiveProductServerErrors = (xhr) => ({
  type: RECEIVE_PRODUCT_ERRORS,
  xhr,
});

const receiveProductUpdateServerErrors = (xhr) => ({
  type: RECEIVE_PRODUCT_UPDATE_ERRORS,
  xhr,
});

export const clearUpdatedProductData = (xhr) => ({
  type: CLEAR_UPDATED_PRODUCT_DATA,
  xhr,
});

const receiveAutoCompleteProductOrHashtagList = (data) => ({
  type: RECEIVE_AUTO_COMPLETE_PRODUCT_OR_HASHTAG_LIST,
  data,
});

const receiveAutoCompleteProductOrHashtagCategories = (data) => ({
  type: RECEIVE_AUTO_COMPLETE_PRODUCT_OR_HASHTAG_CATEGORIES,
  data,
});

export const updateParams = (params) => ({
  type: UPDATE_PRODUCT_PARAMS,
  params,
});

const requestProduct = () => ({ type: REQUEST_PRODUCT });

const receiveProduct = ({ product, pictures }, id) => ({
  type: RECEIVE_PRODUCT,
  product,
  pictures,
  id,
});

const receiveProductVideos = (videos, id) => ({
  type: RECEIVE_PRODUCT_VIDEOS,
  videos,
  id,
});

const receiveProductInfluencers = (influencers, id) => ({
  type: RECEIVE_PRODUCT_INFLUENCERS,
  influencers,
  id,
});

const receiveProductNames = (names) => ({
  type: RECEIVE_PRODUCT_NAMES,
  names,
});

/* eslint-disable */
export const fetchProducts = (params) => (dispatch) => {
  // deleting Extra Param
  delete params.isCategoryPage;
  dispatch(requestProducts());
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/products`,
    data: {
      ...params,
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(response) {
      dispatch(receiveProducts(response));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchCreateProduct = (data, name, isShopify) => (dispatch) => {
  dispatch(requestAddProdsHashtag(name));
  axios
    .post(`${process.env.REACT_APP_BASE_URL}/jwt_api/products`, data, {
      headers: {
        "Content-Type": isShopify ? "application/json" : "multipart/form-data",
      },
    })
    .then((response) => {
      dispatch(receiveCreateProduct(response));
    })
    .catch((error) => {
      dispatch(receiveProductServerErrors(error.response));
    });
};

export const fetchProductNames = () => (dispatch) => {
  dispatch(requestProductNames());
  $.ajax({
    method: "get",
    url: "api/products",
    data: { name: true },
    success(names) {
      dispatch(receiveProductNames(names));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchProduct = (id) => (dispatch) => {
  dispatch(requestProduct());
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/products/${id}`,
    success(product) {
      dispatch(receiveProduct(product, id));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchProductVideos = (id) => (dispatch) => {
  dispatch(requestProductVideos(id));
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/products/${id}/videos`,
    success(videos) {
      dispatch(receiveProductVideos(videos, id));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchProductInfluencers = (id) => (dispatch) => {
  dispatch(requestProductInfluencers(id));
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/products/${id}/influencers`,
    success(influencers) {
      dispatch(receiveProductInfluencers(influencers, id));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchAutoCompleteProductOrHashtagList = (data) => (dispatch) => {
  // dispatch(requestProducts());
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/products/autocomplete_product_or_hashtag_list`,
    headers: {
      Authorization: "Bearer " + Cookies.get("jwt"),
    },
    data,
    success(response) {
      dispatch(receiveAutoCompleteProductOrHashtagList(response));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchAutoCompleteProductOrHashtagCategories =
  (data) => (dispatch) => {
    // dispatch(requestProducts());
    $.ajax({
      method: "get",
      url: `${process.env.REACT_APP_BASE_URL}/jwt_api/products/categories`,
      data,
      success(response) {
        dispatch(receiveAutoCompleteProductOrHashtagCategories(response));
      },
      error(xhr) {
        dispatch(receiveServerErrors(xhr));
      },
    });
  };

export const fetchUpdateProduct = (id, data) => (dispatch) => {
  dispatch(requestEditProdsHashtag());
  axios
    .put(`${process.env.REACT_APP_BASE_URL}/jwt_api/products/${id}`, data, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then((response) => {
      dispatch(receiveUpdateProduct(response));
    })
    .catch((error) => {
      dispatch(receiveProductUpdateServerErrors(error.response));
    });
};
